export var TicketPriority;
(function (TicketPriority) {
    TicketPriority[TicketPriority["LOW"] = 10] = "LOW";
    TicketPriority[TicketPriority["NORMAL"] = 20] = "NORMAL";
    TicketPriority[TicketPriority["HIGH"] = 30] = "HIGH";
})(TicketPriority || (TicketPriority = {}));
export var FileUploadError;
(function (FileUploadError) {
    FileUploadError[FileUploadError["FAILED_UPLOADING_ATTACHMENT"] = -73001] = "FAILED_UPLOADING_ATTACHMENT";
    FileUploadError[FileUploadError["INVALID_EXTENSION"] = -73002] = "INVALID_EXTENSION";
    FileUploadError[FileUploadError["MAX_FILE_SIZE_EXCEEDED"] = -73003] = "MAX_FILE_SIZE_EXCEEDED";
})(FileUploadError || (FileUploadError = {}));
export var AvatarCallCenterAgentStatus;
(function (AvatarCallCenterAgentStatus) {
    AvatarCallCenterAgentStatus[AvatarCallCenterAgentStatus["ONLINE"] = 10] = "ONLINE";
    AvatarCallCenterAgentStatus[AvatarCallCenterAgentStatus["WRAPPING_UP"] = 20] = "WRAPPING_UP";
    AvatarCallCenterAgentStatus[AvatarCallCenterAgentStatus["RESERVED"] = 30] = "RESERVED";
    AvatarCallCenterAgentStatus[AvatarCallCenterAgentStatus["TALKING"] = 40] = "TALKING";
    AvatarCallCenterAgentStatus[AvatarCallCenterAgentStatus["LISTENING"] = 50] = "LISTENING";
    AvatarCallCenterAgentStatus[AvatarCallCenterAgentStatus["BUSY"] = 60] = "BUSY";
    AvatarCallCenterAgentStatus[AvatarCallCenterAgentStatus["OFFLINE"] = 100] = "OFFLINE";
})(AvatarCallCenterAgentStatus || (AvatarCallCenterAgentStatus = {}));
export var AvatarAgentStatus;
(function (AvatarAgentStatus) {
    AvatarAgentStatus[AvatarAgentStatus["ONLINE"] = 10] = "ONLINE";
    AvatarAgentStatus[AvatarAgentStatus["BUSY"] = 60] = "BUSY";
    AvatarAgentStatus[AvatarAgentStatus["OFFLINE"] = 100] = "OFFLINE";
})(AvatarAgentStatus || (AvatarAgentStatus = {}));
//# sourceMappingURL=types.js.map